import { ComponentProps } from '@episerver/spa-core/EpiComponent';
import SimActivationBlockData from 'app/Models/Content/SimActivationBlockData';
import React, { useEffect, useContext } from 'react';
import { useSelector } from 'react-redux';
import { Container } from 'reactstrap';
import SimVerifyPhone from './sections/SimVerifyPhone';
import SimVerifyCode from './sections/SimVerifyCode';
import SimVerifyEnvelope from './sections/SimVerifyEnvelope';
import SimActivationContext from 'app/Components/Page/SimActivationPage/SimActivationContext';
import SimActivate from './sections/SimActivate';
import SimFailed from './sections/SimFailed';
import SimSuccess from './sections/SimSuccess';
import SimNone from './sections/SimNone';
import OutsideBusinessHours from './sections/OutsideBusinessHours';
import { isOpen } from 'app/utilities/ActivityHoursCheck';
import { dwhPortingEntrance } from './reports/dwhReports';


const SimActivationBlock = ({ data, context }: ComponentProps<SimActivationBlockData>) => {
  const [{ stage, activation }, dispatch] = useContext(SimActivationContext);
  const isOpened = isOpen('08:00-20:00', '08:00-12:00', false);
  const userDetails = useSelector((state: any) => state.authentication?.loginData?.userDetails);

  useEffect(() => {
    dwhPortingEntrance({ isOpened, userDetails });
  }, [isOpened]);

  useEffect(() => {
    const links = {
      newLinePurchaseUrl: data.newLinePurchaseUrl.value,
      personalAreaUrl: data.personalAreaUrl.value,
      endButtonUrl: data.endButtonUrl.value,
    };

    dispatch({ type: 'links', links });
    dispatch({ type: 'init' });
  }, [data]);

  return (
    <Container>
      <div className='SimActivationBlock'>
        {isOpened ?
          <>

            {stage == 'Phone' && <SimVerifyPhone esimData={data.esimData} />}
            {stage == 'Code' && <SimVerifyCode esimData={data.esimData} />}
            {stage == 'Envelope' && <SimVerifyEnvelope iContent={data} />}
            {stage == 'Activate' && <SimActivate iContent={data} />}
            {stage == 'Failed' && <SimFailed />}
            {stage == 'Success' && <SimSuccess />}
            {stage == 'None' && <SimNone />}
          </>
          : <OutsideBusinessHours context={context} iContent={data} />}
      </div>
    </Container>
  );
};

export default SimActivationBlock;
